import { exists } from '@/api'

export interface CollectionForwardingRequestAssign {
  bibliographyId: number
  id: number // 資料ID
  collectionNo: string
  collectionRevision: number
}

export function CollectionForwardingRequestAssignFromJSON(
  json: any
): CollectionForwardingRequestAssign {
  return {
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    collectionRevision: exists(json, 'collection_revision')
      ? json.collection_revision
      : 0
  }
}
